import api from 'api';
import type {
  DayProperties,
  DayPropertiesFilter,
  DayPropertiesParams,
} from 'redux/modules/dayProperties.schema';
import { objectToQueryString } from 'utils/url-params';

export const dayPropertiesApi = {
  get: (filters: DayPropertiesFilter = {}): Promise<Array<DayProperties>> => {
    const params = objectToQueryString(filters as Record<string, unknown>);
    return api.get(`day_properties?${params}`);
  },
  getByUserId: (
    userId: number,
    filters: DayPropertiesFilter = {}
  ): Promise<Array<DayProperties>> => {
    const params = objectToQueryString(filters as Record<string, unknown>);
    return api.get(`users/${userId}/day_properties?${params}`);
  },
  save: (params: DayPropertiesParams): Promise<Array<DayProperties>> =>
    api.post('day_properties', { day_property: params }),
};
